import type { InputAudioType } from "@/client/core/Core.api";
import type { AssetWithArtworkUrl } from "@/client/core/platform-types/labs.api";
import { AssetCategorySlug } from "@/client/core/platform-types/types";

export const createInputAudioType = (value: string | null | undefined): InputAudioType | null => {
    if (value === null || value === undefined) {
        return null;
    }
    if (value === AssetCategorySlug.Loop.toString()) {
        return AssetCategorySlug.Loop;
    }
    if (value === AssetCategorySlug.Oneshot.toString()) {
        return AssetCategorySlug.Oneshot;
    }
    return null;
};

export const createInputAudioTypeFromAsset = (
    assetWithArtworkUrl: AssetWithArtworkUrl | undefined,
): InputAudioType | null => {
    return assetWithArtworkUrl?.asset.__typename === "SampleAsset"
        ? createInputAudioType(assetWithArtworkUrl.asset.asset_category_slug)
        : null;
};
